module.exports = __webpack_public_path__ + "static/img/culture7.0d311e0b.jpg";